import React, { FC } from 'react';
import { Icon, InfoLabel } from '@cubeyou-team/hx-react-components';
import classNames from 'classnames';
import styled from 'styled-components';

import { PRODUCT_SLUGS, PRODUCT_ICONS } from '@discover-frontend/constants';

const StyledImageWrapper = styled.div`
  transition: transform 0.3s, border 0.3s;

  img {
    cursor: pointer;
    border-radius: 0.25rem;
  }

  &:hover {
    transform: scale(1.15);
  }
`;

export const ProductIcon: FC<any> = ({ product }) => {
  const isCsm = product.slug === PRODUCT_SLUGS.HELIXA_CSM;

  return (
    <div className="rounded-md border-2 border-hx-light-dark shadow-md relative">
      <div className="flex items-center justify-center">
        <StyledImageWrapper>
          <div
            className={classNames(
              'w-20 h-20 rounded-md flex items-center justify-center',
              isCsm ? 'bg-hx-primary' : 'bg-hx-secondary'
            )}
          >
            <Icon
              variant="light"
              icon={PRODUCT_ICONS.products[product.slug]}
              size="xlarge"
            />
          </div>
        </StyledImageWrapper>
      </div>
    </div>
  );
};
